import { render, staticRenderFns } from "./FastTools.vue?vue&type=template&id=5a87bd2c&scoped=true&"
import script from "./FastTools.vue?vue&type=script&lang=js&"
export * from "./FastTools.vue?vue&type=script&lang=js&"
import style0 from "./FastTools.vue?vue&type=style&index=0&id=5a87bd2c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a87bd2c",
  null
  
)

export default component.exports